import React from 'react'

const PurchaseOrders = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Purchase Orders</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Purchases & Suppliers</li>
            <li className="breadcrumb-item active">Purchase Orders</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-cart-check me-2"></i>
                  Purchase Orders
                </h5>
                <p>Create and manage purchase orders. Track order status, view pending orders, and monitor deliveries from suppliers.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default PurchaseOrders

